module.exports = __webpack_public_path__ + "assets/img/logonew2.d47d522b.png";